module.exports = __webpack_public_path__ + "bf5ec705815eae3a49059f34620931b4.svg";